<template>
  <v-container>
    <!--Pages-->
    <v-card flat color="transparent">
      <v-card-text>
        <v-fab-transition v-if="screen.transaction.canvasDraw">
          <v-btn
            color="#aaa"
            fab
            small
            absolute
            bottom
            right
            @click="addPage(-1, 'bellow')"
            hint="add page"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-card-text>
    </v-card>
    <div v-for="(page, pageIndex) in pages()" :key="pageIndex">
      <v-card color="#aaa">
        <v-card-title>
          {{ translatedText("canvasPage") }} {{ pageIndex + 1 }}
        </v-card-title>
        <v-card-text>
          <v-fab-transition v-if="screen.transaction.canvasDraw">
            <v-btn
              color="#aaa"
              fab
              small
              absolute
              bottom
              right
              @click="addPage(pageIndex, 'bellow')"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-fab-transition>
          <v-fab-transition v-if="screen.transaction.canvasDraw">
            <v-btn
              color="#aaa"
              fab
              x-small
              absolute
              bottom
              left
              @click="deletePage(pageIndex)"
            >
              <v-icon color="pink lighten-4">mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-fab-transition>

          <!--Lines-->
          <v-card flat color="transparent">
            <v-card-text>
              <v-fab-transition v-if="screen.transaction.canvasDraw">
                <v-btn
                  color="#ddd"
                  fab
                  small
                  absolute
                  bottom
                  right
                  @click="addLine(pageIndex, -1, 'bellow')"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-text>
          </v-card>
          <div v-for="(line, lineIndex) in lines(pageIndex)" :key="lineIndex">
            <v-card color="#ddd">
              <br />
              <v-card-subtitle>
                {{ translatedText("canvasLine") }} {{ lineIndex + 1 }}
              </v-card-subtitle>
              <v-card-text>
                <v-fab-transition v-if="screen.transaction.canvasDraw">
                  <v-btn
                    color="#ddd"
                    fab
                    small
                    absolute
                    bottom
                    right
                    @click="addLine(pageIndex, lineIndex, 'bellow')"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-fab-transition>
                <v-fab-transition v-if="screen.transaction.canvasDraw">
                  <v-btn
                    color="#ddd"
                    fab
                    x-small
                    absolute
                    bottom
                    left
                    @click="deleteLine(pageIndex, lineIndex)"
                  >
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-fab-transition>

                <v-row>
                  <v-col cols="1">
                    <v-card flat color="transparent">
                      <v-card-text>
                        <v-fab-transition
                          v-if="
                            columnsCount(pageIndex, lineIndex) <= 0 &&
                            screen.transaction.canvasDraw
                          "
                        >
                          <v-btn
                            color="primary"
                            fab
                            x-small
                            absolute
                            right
                            @click="addColumn(pageIndex, lineIndex, 0, 'above')"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-fab-transition>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="11">
                    <v-row>
                      <v-col
                        v-for="(column, columnIndex) in columns(
                          pageIndex,
                          lineIndex
                        )"
                        :key="columnIndex"
                        :cols="columnSpan(pageIndex, lineIndex)"
                      >
                        <div
                          v-for="(item, itemIndex) in items(
                            pageIndex,
                            lineIndex,
                            columnIndex
                          )"
                          :key="itemIndex"
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-fab-transition
                                v-if="
                                  screen.transaction.massive === true &&
                                  screen.transaction.canvasDraw
                                "
                              >
                                <v-btn
                                  color="primary"
                                  fab
                                  x-small
                                  absolute
                                  right
                                  bottom
                                  @click="
                                    addColumn(
                                      pageIndex,
                                      lineIndex,
                                      columnIndex,
                                      'bellow'
                                    )
                                  "
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </v-fab-transition>

                              <v-fab-transition
                                v-if="
                                  screen.transaction.massive === true &&
                                  screen.transaction.canvasDraw
                                "
                              >
                                <v-btn
                                  color="white"
                                  fab
                                  x-small
                                  absolute
                                  left
                                  bottom
                                  @click="
                                    deleteColumn(
                                      pageIndex,
                                      lineIndex,
                                      columnIndex
                                    )
                                  "
                                >
                                  <v-icon color="red"
                                    >mdi-trash-can-outline</v-icon
                                  >
                                </v-btn>
                              </v-fab-transition>

                              <v-menu
                                v-if="!screen.transaction.massive"
                                v-model="
                                  canvasActions[
                                    'P' +
                                      pageIndex +
                                      'L' +
                                      lineIndex +
                                      'C' +
                                      columnIndex +
                                      'I' +
                                      itemIndex
                                  ]
                                "
                                :close-on-content-click="true"
                                :nudge-width="200"
                                offset-y
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <v-list> </v-list>

                                  <v-list>
                                    <div
                                      v-for="(action, index) in allActions"
                                      :key="index"
                                    >
                                      <v-list-item
                                        link
                                        @click="
                                          canvasCallAction(
                                            action.destTranName,
                                            action.inputFields,
                                            action.method,
                                            true,
                                            {
                                              page: pageIndex,
                                              line: lineIndex,
                                              column: columnIndex,
                                            }
                                          )
                                        "
                                      >
                                        <v-list-item-action>
                                          <v-list-item-action-text no-action>
                                            <v-icon>{{ action.icon }}</v-icon>
                                            {{ action.caption }}
                                          </v-list-item-action-text>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </div>
                                  </v-list>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-menu>

                              <v-row>
                                <v-col>
                                  <v-simple-table>
                                    <template v-slot:default>
                                      <tbody>
                                        <tr
                                          v-for="(
                                            queryFieldEx, fieldIndex
                                          ) in screen.queryFieldsEx"
                                          :key="fieldIndex"
                                        >
                                          <td
                                            v-show="
                                              queryFieldEx.queryField.access !=
                                              'hidden'
                                            "
                                          >
                                            {{
                                              queryFieldEx.queryField.caption
                                            }}
                                          </td>
                                          <td
                                            v-show="
                                              queryFieldEx.queryField.access !=
                                              'hidden'
                                            "
                                          >
                                            <QueryField
                                              :id="
                                                'canvasField_' +
                                                queryFieldEx.queryField
                                                  .fieldName +
                                                '_' +
                                                'P' +
                                                pageIndex +
                                                'L' +
                                                lineIndex +
                                                'C' +
                                                columnIndex +
                                                'I' +
                                                itemIndex
                                              "
                                              :dictionary="
                                                queryFieldEx.dictionary
                                              "
                                              :items="
                                                queryFieldEx.catalogEx.items
                                              "
                                              :value="
                                                canvasItemValue(
                                                  pageIndex,
                                                  lineIndex,
                                                  columnIndex,
                                                  queryFieldEx.queryField
                                                    .fieldName
                                                )
                                              "
                                              :access="
                                                queryFieldEx.queryField.access
                                              "
                                              :preview="
                                                queryFieldEx.queryField.preview
                                              "
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                  {{ item.name }}
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
              <br />
            </v-card>
            <br />
            <br />
          </div>
        </v-card-text>
        <br />
        <br />
      </v-card>
      <br />
    </div>
    <ButtonField
      v-if="screen.transaction.massive === true"
      @click="submitCanvas"
    >
    </ButtonField>
  </v-container>
</template>

<script>
import ButtonField from "./fields/ButtonField";
import QueryField from "./fields/QueryField";
export default {
  name: "Canvas",
  props: [
    "transactionName",
    "screen",
    "canvasData",
    "canvasActions",
    "inputData",
    "allActions",
    "pagesName",
    "linesName",
    "columnsName",
    "itemsName",
  ],
  display: "Canvas",
  order: 0,
  components: {
    QueryField,
    ButtonField,
  },
  data() {
    return {
      enabled: true,
      dragging: false,
    };
  },
  methods: {
    // Data Functions

    pages() {
      return this.canvasData[this.pagesName]
        ? this.canvasData[this.pagesName]
        : [];
    },

    lines(getPage) {
      return this.pages()[getPage][this.linesName]
        ? this.pages()[getPage][this.linesName]
        : [];
    },

    columns(getPage, getLine) {
      return this.lines(getPage)[getLine][this.columnsName]
        ? this.lines(getPage)[getLine][this.columnsName]
        : [];
    },

    items(getPage, getLine, getColumn) {
      return this.columns(getPage, getLine)[getColumn][this.itemsName]
        ? this.columns(getPage, getLine)[getColumn][this.itemsName]
        : [];
    },

    pagesCount() {
      return this.pages().length;
    },

    linesCount(getPage) {
      return this.lines(getPage).length;
    },

    columnsCount(getPage, getLine) {
      return this.columns(getPage, getLine).length;
    },

    columnSpan(getPage, getLine) {
      let result = Math.trunc(12 / this.columnsCount(getPage, getLine));
      return result.toString();
    },

    addPage(getPage, getMode) {
      this.$emit("canvas-add-page", getPage, getMode);
    },

    addLine(getPage, getLine, getMode) {
      this.$emit("canvas-add-line", getPage, getLine, getMode);
    },

    addColumn(getPage, getLine, getColumn, getMode) {
      if (this.screen.transaction.massive === true) {
        this.$emit("canvas-add-column", getPage, getLine, getColumn, getMode);
      } else {
        this.allActions.forEach((action) => {
          if (action.method == "post") {
            this.$emit(
              "call-action",
              action.destTranName,
              action.inputFields,
              action.method,
              true,
              { page: getPage, line: getLine, column: getColumn }
            );
          }
        });
      }
    },

    deletePage(getPage) {
      this.$emit("canvas-delete-page", getPage);
    },

    deleteLine(getPage, getLine) {
      this.$emit("canvas-delete-line", getPage, getLine);
    },

    deleteColumn(getPage, getLine, getColumn) {
      this.$emit("canvas-delete-column", getPage, getLine, getColumn);
    },

    submitCanvas() {
      this.$emit("submit-canvas");
    },

    canvasCallAction(
      getTransactionName,
      getInputFields,
      getMethod,
      getDynamic,
      getCoordinates
    ) {
      let coordinates = getCoordinates;
      if (getMethod == "post") {
        coordinates.column++;
      }
      this.$emit(
        "call-action",
        getTransactionName,
        getInputFields,
        getMethod,
        getDynamic,
        coordinates
      );
    },

    canvasItemValue(pageIndex, lineIndex, columnIndex, fieldName) {
      return this.items(pageIndex, lineIndex, columnIndex)[0][fieldName];
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
